
import { defineComponent, ref, inject, onMounted, computed, watch } from 'vue'
import { Search } from '@element-plus/icons-vue'
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useRouter } from 'vue-router';
//services
import EventService from "@/core/services/EventService"
import { errManager, showMessage } from "@/core/config/Tools";

//components
import AddEdit from "./AddEdit.vue"

export default defineComponent({
    name: "Events",
    components: {
        AddEdit,
    },
    setup() {
        const router = useRouter();
        //get sharing data
        const gblPeriodo = inject < any > ('gblPeriodo')
        const gblDialog = inject < any > ('gblDialog')
        const gblAction = inject < any > ('gblAction')
        
        const loader = ref(false)
        const listEvents = ref < any > ([])
        const searchText = ref('')
        const setting = ref({})
        const filter = ref({
            type: '',
            periodo: ''
        })
        const rowItem = ref({})

        const getEventos = async () => {
            loader.value = true
            listEvents.value.length = 0
            filter.value.periodo = gblPeriodo.value
            console.log(filter.value.periodo)
            await EventService.getList(filter.value)
                .then((res) => {
                    listEvents.value = res.data
                    loader.value = false
                }).catch(({
                    response
                }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const getSetting = async () => {
            await EventService.getSetting()
            .then( (res) => {
                setting.value = res.data
            }).catch( ({response}) => {
                errManager(response, null, 2)
            })
        }

        const filteredEvents = computed(() => {
            return listEvents.value.filter(
                (item) =>
                item.name.toLowerCase().includes(searchText.value.toLowerCase())
            );
        });

        const onRegister = () => {
            gblAction.value = 'new';
            gblDialog.value = true
        }

        const onResponse = (data) => {
            gblDialog.value = false
            showMessage(data)
            if (data.status == 'success')
                getEventos()
        }

        const getRegisterClass = (register) => {
            return register == 1 ? 'success' : 'danger'
        }

        const getRegisterStatus = (register) => {
            return register == 1 ? 'habilitadas' : 'finalizadas'
        }

        const getDate = (date1: any, date2: any) => {
            let dat1 = moment(date1).format("DD MMM")
            let dat2 = moment(date1).format("DD/MM/YYYY") != moment(date2).format("DD/MM/YYYY") ? ' al ' + moment(date2).format('DD MMM YYYY') : ''

            return dat1 + `<span>${dat2}</span>`
        }

        const onEdit = (row) => {
            rowItem.value = row
            gblAction.value = 'edit';
            gblDialog.value = true
        } 

        const onDelete = (row) => {
            Swal.fire({
                title: 'Eliminar evento',
                text: `¿Desea eliminar el evento ${row.name} de forma permanente?`,
                icon: 'warning',
                showClass: {
                    popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                },
                showCancelButton: true,
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Mantener',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return EventService.delete(row.idevent)
                    .then( (res) => {
                        return res.data
                    }).catch(({response}) => {
                        Swal.showValidationMessage(
                        `Request failed: ${response}`
                        )
                    })
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        icon: result.value.status,
                        title: result.value.title,
                        html: result.value.message
                    })
                    result.value.status === 'success' && getEventos();
                }   
            })
        }

        const onManager = (row) => {
            router.push(`/events/${row.idevent}/manager/home`);
        }

        onMounted(() => {
            searchText.value = ''
            filter.value.type = ''
            filter.value.periodo = gblPeriodo.value
            getSetting()
            getEventos()
        })

        watch(() => gblPeriodo.value, getEventos);

        return {
            loader,
            Search,
            gblPeriodo,
            filter,
            rowItem,
            searchText,
            listEvents,
            setting,
            //events
            getEventos,
            getSetting,
            filteredEvents,
            onRegister,
            onResponse,
            getRegisterClass,
            getRegisterStatus,
            getDate,
            onDelete,
            onEdit,
            onManager
        }
    }
})
